$('.your-location-pick').on('click', (e) => {
  const $option = $(e.currentTarget);
  const $locationCode = $option.data('yourlocation');
  const $input = $(`<input name="yourlocation" type="hidden" value="${$locationCode}">`);
  const $yourlocationPickerForm = $('#your-location-picker');
  $yourlocationPickerForm.append($input);
  $yourlocationPickerForm.submit();
});
